import React from 'react';
import LightBoxLogin from 'components/light-box-login/light-box-login';
import { LightBoxLoginProvider } from 'components/light-box-login/use-light-box-login';

const LightBoxLoginWrapper = (props) => {
  return (
    <LightBoxLoginProvider>
      <LightBoxLogin {...props} />
    </LightBoxLoginProvider>
  );
};

export default LightBoxLoginWrapper;
